import type { LinkAsButtonVariant } from '@property.com.au/ui-kit';

export type LinkVariant =
  | 'NAKED'
  | 'PRIMARY'
  | 'SECONDARY'
  | 'OUTLINE'
  | 'INLINE'
  | 'BUTTON_PRIMARY'
  | 'BUTTON_SECONDARY'
  | 'BUTTON_SHADOW'
  | 'OUTLINE_SECONDARY';

export const mapButtonLinkVariant = (variant: LinkVariant): LinkAsButtonVariant => {
  switch (variant) {
    case 'PRIMARY':
      return 'button-primary';
    case 'SECONDARY':
      return 'button-secondary';
    case 'OUTLINE':
      return 'button-outline';
    case 'OUTLINE_SECONDARY':
      return 'button-outline-secondary';
    case 'NAKED':
      return 'button-naked';
    default:
      return 'button-primary';
  }
};
